module.exports = __webpack_public_path__ + "static/media/pt-sessions-logo-lg.b533bb51.svg";